import React from "react";
import { FileInput } from "../../FileInput";
import { useFpApi } from "../../notes-hooks";

export function AddAttachment({ objectId }: { objectId: string }) {
  const api = useFpApi();
  return <FileInput onAdd={(file) => api.attachFile(objectId, file)} />;
}
